var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2959 9.79598L12.7959 17.296C12.6914 17.4009 12.5672 17.4841 12.4304 17.5409C12.2937 17.5976 12.1471 17.6269 11.999 17.6269C11.851 17.6269 11.7043 17.5976 11.5676 17.5409C11.4309 17.4841 11.3067 17.4009 11.2021 17.296L3.70215 9.79598C3.4908 9.58464 3.37207 9.29799 3.37207 8.9991C3.37207 8.70022 3.4908 8.41357 3.70215 8.20223C3.91349 7.99089 4.20014 7.87215 4.49902 7.87215C4.79791 7.87215 5.08455 7.99089 5.2959 8.20223L12 14.9063L18.704 8.20129C18.9154 7.98995 19.202 7.87122 19.5009 7.87122C19.7998 7.87122 20.0864 7.98995 20.2978 8.20129C20.5091 8.41264 20.6278 8.69928 20.6278 8.99817C20.6278 9.29705 20.5091 9.5837 20.2978 9.79504L20.2959 9.79598Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrowIcon.d1c5913120c4b304012e6a4d7e03a1bf.svg";
export { ForwardRef as ReactComponent };